// src/runtime/KnowledgeEvolutionRuntime/config.ts
// ============================================
// Knowledge Evolution Runtime 配置
//
// 依据白皮书第十五章《Knowledge Evolution Protocol》：
//   - 每天 23:00 自动启动
//   - 两层知识体系：30_Inbox（候选知识）→ 夜间整理 → 正式知识库
//   - 低风险自动通过 / 中风险待确认 / 高风险必须 CEO 确认
// ============================================

export interface KnowledgeEvolutionConfig {
  /** 运行时名称 */
  name: string;
  /** 版本号 */
  version: string;
  /** 描述 */
  description: string;
  /** 候选知识目录（相对 Vault 根） */
  inboxDir: string;
  /** 正式知识库目录（相对 Vault 根，09_Knowledge/Cards/） */
  knowledgeBaseDir: string;
  /** 日报目录（相对 Vault 根） */
  reportDir: string;
  /** 每天自动运行时间（HH:mm） */
  scheduleTime: string;
  /** 单次提取上限（防止单次运行写入过多） */
  maxCandidatesPerRun: number;
  /** 低风险自动入库的最低评分 */
  autoApproveMinScore: number;
  /** 高风险判定：涉及战略/财务/对外承诺的关键词 */
  highRiskKeywords: string[];
  /** 中风险判定：涉及客户/产品/对外表述的关键词 */
  mediumRiskKeywords: string[];
  /** 启发式提取的最小句子长度（字符） */
  minSentenceLength: number;
}

const config: KnowledgeEvolutionConfig = {
  name: 'Knowledge Evolution Runtime',
  version: '1.0.0',
  description:
    '知识演化 Runtime - 企业每天自动学习、沉淀、演化（后台运行，不占用 Workspace）',
  inboxDir: '30_Inbox',
  knowledgeBaseDir: '09_Knowledge（知识中心）/Cards',
  reportDir: '10_Operations（运营层）/Daily',
  scheduleTime: '23:00',
  maxCandidatesPerRun: 20,
  autoApproveMinScore: 60,
  highRiskKeywords: [
    '战略',
    '融资',
    '投资',
    '预算',
    '定价',
    '价格',
    '合同',
    '签约',
    '承诺',
    '法律',
    '合规',
    '退款',
    '股权',
    '分红',
    '裁员',
    '诉讼',
    '处罚',
  ],
  mediumRiskKeywords: [
    '客户',
    '报价',
    '折扣',
    '优惠',
    '案例',
    '交付',
    '方案',
    '产品',
    '品牌',
    '发布',
    '对外',
    '宣传',
    '公众号',
    '广告',
  ],
  minSentenceLength: 12,
};

export default config;
